module.exports = __webpack_public_path__ + "static/media/Choice.03773311.svg";